export const DATE_FORMAT = 'MMM D, YYYY';

export const MOBILE_WIDTH = 767;

export const esriCurrentYear = (new Date()).getMonth() > 5
  ? (new Date()).getFullYear()
  : (new Date()).getFullYear() - 1;

export const esriProjectedYear = esriCurrentYear + 5;

export const MAP_TYPES = {
  ROADMAP: 'ROADMAP',
  STREET: 'ROADMAP',
  TERRAIN: 'TERRAIN',
  SATELLITE: 'SATELLITE',
  HYBRID: 'HYBRID',
};

export const PROPERTY_TYPES = {
  BUILDINGS: 'buildings',
  SITES: 'sites',
  AREAS: 'areas',
};

export const ESRI_RADII_DEFAULTS = {
  radiusOne: 10,
  radiusTwo: 20,
  radiusThree: 30,
};

export const ESRI_YEAR_DEFAULTS = {
  currentYear: esriCurrentYear,
  projectedYear: esriProjectedYear,
};

export const LAZY_DEFAULTS = {
  INITIAL: 50,
  MORE: 30,
};

export const OCCUPATION_DICT = {
  11: 'Management Occupations',
  13: 'Business and Financial Operations Occupations',
  15: 'Computer and Mathematical Occupations',
  17: 'Architecture and Engineering Occupations',
  19: 'Life, Physical, and Social Science Occupations',
  21: 'Community and Social Services Occupations',
  23: 'Legal Occupations',
  25: 'Education, Training, and Library Occupations',
  27: 'Arts, Design, Entertainment, Sports, and Media Occupations',
  29: 'Healthcare Practitioners and Technical Occupations',
  31: 'Healthcare Support Occupations',
  33: 'Protective Service Occupations',
  35: 'Food Preparation and Serving Related Occupations',
  37: 'Building and Grounds Cleaning and Maintenance Occupations',
  39: 'Personal Care and Service Occupations',
  41: 'Sales and Related Occupations',
  43: 'Office and Administrative Support Occupations',
  45: 'Farming, Fishing, and Forestry Occupations',
  47: 'Construction and Extraction Occupations',
  49: 'Installation, Maintenance, and Repair Occupations',
  51: 'Production Occupations',
  53: 'Transportation and Material Moving Occupations',
  55: 'Military Specific Occupations',
};

export const INDUSTRY_DICT = {
  11: 'Agriculture, Forestry, Fishing and Hunting',
  21: 'Mining, Quarrying, and Oil and Gas Extraction',
  22: 'Utilities',
  23: 'Construction',
  31: 'Manufacturing',
  42: 'Wholesale Trade',
  44: 'Retail Trade',
  48: 'Transportation and Warehousing',
  51: 'Information',
  52: 'Finance and Insurance',
  53: 'Real Estate and Rental and Leasing',
  54: 'Professional, Scientific, and Technical Services',
  55: 'Management of Companies and Enterprises',
  56: 'Administrative and Support and Waste Management and Remediation Services',
  61: 'Educational Services',
  62: 'Health Care and Social Assistance',
  71: 'Arts, Entertainment, and Recreation',
  72: 'Accommodation and Food Services',
  81: 'Other Services (except Public Administration)',
  90: 'Government',
  99: 'Unclassified Industry',
};

export const DEFAULT_ZOOM_LEVEL = 0;

export const MIN_DEMOGRAPHICS_ZOOM_LEVEL = 9;

export const MIN_WORKFORCE_ZOOM_LEVEL = 10;

// API endpoints for reports
export const REPORT_API_ENDPOINTS = {
  PIN_WORKFORCE_REPORT: 'https://takqptsb3t.us-east-1.awsapprunner.com/api/generateReport/PinWorkforceReport',
  FEATURE_WORKFORCE_REPORT: 'https://takqptsb3t.us-east-1.awsapprunner.com/api/generateReport/FeatureWorkforceReport',

  // remove in prod -- for local testing
  // PIN_WORKFORCE_REPORT: 'http://localhost:3031/api/generateReport/PinWorkforceReport',
  // FEATURE_WORKFORCE_REPORT: 'http://localhost:3031/api/generateReport/FeatureWorkforceReport',

};

export const WORKFORCE_LEGEND_BOUNDS = {
  wages: [20000, 40000, 60000, 80000, 100000],
  emp_count: [20, 50, 100, 200, 500],
};

export const WORKFORCE_COLOR_SCALES = {
  wages: [
    '#08519c', // Dark Blue (lowest)
    '#3182bd', // Blue
    '#6baed6', // Light Blue
    '#bdd7e7', // Very Light Blue
    '#fdae6b', // Light Orange
    '#fd8d3c', // Orange
    '#d94801', // Dark Orange (highest)
  ],
  emp_count: [
    '#08519c', // Dark Blue (lowest)
    '#3182bd', // Blue
    '#6baed6', // Light Blue
    '#bdd7e7', // Very Light Blue
    '#fdae6b', // Light Orange
    '#fd8d3c', // Orange
    '#d94801', // Dark Orange (highest)
  ],
};

export default ({
  DATE_FORMAT,
  LAZY_DEFAULTS,
  MAP_TYPES,
  DEFAULT_ZOOM_LEVEL,
  MIN_DEMOGRAPHICS_ZOOM_LEVEL,
  MOBILE_WIDTH,
  PROPERTY_TYPES,
  ESRI_YEAR_DEFAULTS,
  REPORT_API_ENDPOINTS,
  WORKFORCE_LEGEND_BOUNDS,
  WORKFORCE_COLOR_SCALES,
});

export const SHORT_LINE_RAIL_OPTIONS = {
  AKDN: 'Acadiana Railway Co.',
  AGCR: 'Alamo Gulf Coast Railroad',
  AERC: 'Albany & Eastern Railroad Company',
  ANR: 'Angelina & Neches River Railroad Co.',
  AZER: 'Arizona Eastern Railway Company',
  AKMD: 'Arkansas Midland Railroad Co Inc.',
  AOK: 'Arkansas-Oklahoma Railroad Inc',
  AWRR: 'Austin Western Railroad',
  BXN: 'Bauxite & Northern Railway Company',
  BSR: 'Big Spring Railroad',
  BLR: 'Blacklands',
  BLMR: 'Blue Mountain Railroad Inc.',
  BVRR: 'Boise Valley Railroad',
  BSVY: 'Boone & Scenic Valley Railroad',
  BRG: 'Brownsville & Rio Grande International RR',
  CFNR: 'California Northern Railroad Company',
  CSR: 'Camden & Southern Railroad',
  CIC: 'Cedar Rapids & Iowa City Railway Company',
  CMR: 'Central Midland Railway Company',
  CORP: 'Central Oregon & Pacific',
  CJR: 'Chicago Junction Railway',
  CBR: 'Coos Bay Rail Link',
  CBRY: 'Copper Basin Railway Inc.',
  COER: 'Crab Orchard & Egyptian Railway',
  DGNO: 'Dallas Garland & Northeastern Railroad Inc.',
  DR: 'Dardanelle & Russellville Railroad',
  DSRR: 'Delta Southern Railroad Company',
  EACH: 'East Camden & Highland RR',
  EIRR: 'Eastern Idaho Railroad Inc.',
  EE: 'Ellis & Eastern Railroad',
  FP: 'Fordyce & Princeton Railroad Co.',
  FSR: 'Fort Smith Railroad Co.',
  FWWR: 'Fort Worth & Western Railroad',
  GRD: 'Gardendale Railroad',
  HOB: 'Henderson Overton Railroad',
  INPR: 'Idaho Northern & Pacific RR Company',
  IANR: 'Iowa Northern Railroad',
  IATR: 'Iowa Traction Railway Co.',
  KO: 'Kansas & Oklahoma Railroad Inc.',
  KNOR: 'Klamath Northern Railway Company',
  KYLE: 'Kyle Railroad Company',
  GOOS: 'Lake Railway',
  LDRR: 'Louisiana & Delta Railway Co.',
  LNW: 'Louisiana & North West Railroad Co.',
  MNNR: 'Minnesota Commercial Railway',
  MPLI: 'Minnesota Prairie Line',
  MNA: 'Missouri & Northern Arkansas Railroad Company Inc.',
  MCSA: 'Moscow, Camden & San Augustine Railroad',
  MH: 'Mt Hood Railroad Co.',
  NCRC: 'Nebraska Central Railroad Company',
  NOGC: 'New Orleans & Gulf Coast Railway Co.',
  NLA: 'North Louisiana & Arkansas Railroad',
  NWP: 'Northwestern Pacific Railroad',
  OERR: 'Oregon Eastern Railroad',
  OPR: 'Oregon Pacific Railroad Co.',
  PCC: 'Palouse River & Coulee City Railroad Inc.',
  PVS: 'Pecos Valley Southern Railway Company',
  PCN: 'Point Comfort & Northern Railway Company',
  PRI: 'Port Rail, Inc.',
  PNWR: 'Portland & Western Railroad',
  PNW: 'Prescott And Northwestern Railroad Company',
  CVRC: 'Progressive Rail Inc. D/B/A Cannon Valley Railroad Co / Faribault Line',
  WN: 'Progressive Rail Inc D/B/A Wisconsin',
  PRR: 'Progressive Rail/Rosemount',
  QRR: 'Quincy Railroad Company',
  RJCD: 'R.J. Corman Railroad Company/Texas Line LLC',
  RPRC: 'Richmond Pacific Railroad Corporation',
  RVSC: 'Rio Valley Switching',
  RSS: 'Rockdale Sandow & Southern Railroad Co.',
  SAC: 'San Antonio Central Railroad',
  SJVR: 'San Joaquin Valley Railroad Co',
  SPSR: 'San Pedro And Southwestern Railroad',
  SMV: 'Santa Maria Valley Railroad Company',
  STS: 'Santa Teresa Railroad',
  SBG: 'Savage Bingham & Garfield Railroad',
  SE: 'Semo Port Railroad Inc.',
  SKOL: 'South Kansas & Oklahoma Railroad Inc.',
  SSC: 'Southern Switching',
  SPP: 'St. Paul & Pacific Railroad',
  TXN: 'Texas & New Mexico Railway',
  TNER: 'Texas Northeastern Division Mid-Michigan Railroad Inc.',
  TXGN: 'Texas, Gonzales & Northern Railway',
  PSAP: 'The Puget Sound & Pacific Railroad Co.',
  TRC: 'Trona Railway Company',
  TSU: 'Tulsa-Sapulpa Union Railway Company LLC',
  TCWR: 'Twin Cities & Western Railroad',
  UCRY: 'Utah Central Railway Company',
  VCRR: 'Ventura County Railroad Company',
  WSR: 'Warren & Saline River Railroad Co.',
  WTJR: 'Wichita Tillman & Jackson Railway Company Inc',
  WVR: 'Willamette Valley Railway Co, Inc.',
  CSS: 'Chicago South Shore',
  CR: 'City of Rochelle',
  IIRL: 'Iowa Interstate Railroad, Ltd.',
  IRR: 'Iowa River Railroad',
  PHR: 'Port Harbor Railroad',
  SLRI: 'Sidney & Lowe Railroad, Inc.',
  TRAS: 'Terminal Railroad Association of St. Louis',
};

// A list of ALL reports from ESRI are here:
// https://geoenrich.arcgis.com/arcgis/rest/services/World/geoenrichmentserver/Geoenrichment/Reports/US?f=pjson
export const REPORTS = {
  US: [
    { title: 'Community Profile', report: 'community_profile' },
    { title: '2010 Census Profile', report: 'census2010_profile' },
    { title: '2020 Census PL 94-171', report: 'census2020_profile' },
    { title: 'Business Summary', report: 'business_summary' },
    { title: 'Demographic and Income Profile', report: 'dandi' },
    { title: 'Disposable Income Report', report: 'dispinc' },
    { title: 'Dominant Tapestry Site Map', report: 'tapestry_profileNEW' },
    { title: 'Executive Summary', report: 'execsummary' },
    { title: 'Graphic Profile', report: 'graphic' },
    { title: 'House and Home Expenditures', report: 'cex_home' },
    { title: 'Household Budget Expenditures', report: 'cex_budget' },
    { title: 'Household Income Report', report: 'hh_income' },
    { title: 'Housing Profile', report: 'housing' },
    { title: 'Market Profile', report: 'market_profile' },
    { title: 'Retail Goods and Services Expenditures', report: 'cex_retail' },
    { title: 'Retail Marketplace Potential', report: 'mpi_retail' },
    { title: 'Time Series Profile', report: 'time_series' },
    { title: 'Traffic Count Map', report: 'traffic_map' },
    { title: 'Traffic Count Map - Close Up', report: 'traffic_map08' },
    { title: 'Workforce Industry/Occupation Data', report: 'laborforce_profile' },
  ],

  CA: [
    { title: 'Market Profile', report: 'DEPMarketProfile' },
    { title: 'Age By Sex', report: 'AgeSexCanada' },
    { title: 'Age 65+ Profile', report: 'DEP65plus' },
    { title: 'Occupation Profile', report: 'DEPOccupation' },
    { title: 'Detailed Income Profile', report: 'DetailIncCanada' },
    { title: 'Family Report', report: 'FamilyCanada' },
    { title: 'Housing Profile', report: 'HousingCanada' },
    { title: 'Language and Ethnicity Profile', report: 'LangEthCanada' },
  ],

  MX: [
    { title: 'Summary Report', report: 'MexicoSummaryReport' },
  ],
};



// WEBPACK FOOTER //
// ./src/constants.js